import React from "react";
import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import toast, { Toaster } from "react-hot-toast";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import PreferencesNav from "./PreferencesNav";
import AddIcon from "@mui/icons-material/Add";

import { addTcs, editTcs, getTcsAllRecords } from "../../services/Purchase/TcsService";

const TCS = () => {
  const [tcsRate, setTcsRate] = useState({});
  const [filteredData, setFilteredData] = useState([]);

  const [show, setShow] = useState(false);
  const handleClose = () => {
    setTcsRate({});
    setShow(false);
  };

  useEffect(() => {
    getTcsList();
  }, []);

  const getTcsList = () => {
    var data = {
      page: 0,
      search: "",
      size: -1,
    };
    getTcsAllRecords(data).then((res) => {
      if (res.errorCode == 0) {
        var d = res.responsePacket.data;
        setFilteredData(d);
      } else {
        toast(res.message);
        return;
      }
    });
  };

  const columns = [
    {
      name: "Rate",
      cell: (row) => row.tcsRate,
    },
  ];

  const handleClicked = (row) => {
    setTcsRate({
      ...tcsRate,
      recordId: row?.recordId,
      tcsRate: row?.tcsRate,
    });
    setShow(true);
  };

  const handleData = (e) => {
    setTcsRate({
      ...tcsRate,
      [e.target.name]: e.target.value,
    });
  };

  const handleSave = () => {
    if (!tcsRate.tcsRate) {
      toast("Please fill rate");
      return;
    }

    const data = {
        tcsRate: tcsRate.tcsRate,
    };
    if (tcsRate.recordId) {
        editTcs(tcsRate.recordId, data).then((res) => {
        if (res.errorCode == 0) {
          toast.success(res.message);
          getTcsList();
          handleClose();
        } else {
          toast(res.message);
          return;
        }
      });
    } else {
        addTcs(data).then((res) => {
        if (res.errorCode == 0) {
          toast.success(res.message);
          getTcsList();
          handleClose();
        } else {
          toast(res.message);
          return;
        }
      });
    }
  };

  return (
    <>
      <Modal show={show} onHide={handleClose} size="sm">
        <Modal.Header>TCS Info</Modal.Header>
        <Modal.Body>
          <table>
            <tr>
              <td>Rate:</td>
              <td>
                <input
                  autoComplete="off"
                  className="form-control"
                  type="number"
                  name="tcsRate"
                  value={tcsRate.tcsRate}
                  onChange={(e) => handleData(e)}
                />
              </td>
            </tr>
          </table>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="primary" onClick={handleSave}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>

      {/* <div className="column list-column d-print-none column-small">
        <PreferencesNav />
      </div> */}
      <div className="column content-column">
        <div className="header clearfix" style={{ borderBottom: "none" }}>
          <span className="float-left" style={{ fontSize: "35px" }}>
            TCS List
          </span>
        </div>

        <div style={{ height: 500, width: "100%" }}>
          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            onRowClicked={(data) => {
              handleClicked(data);
            }}
            fixedHeader
            subHeader
            // subHeaderComponent={
            //   <>
            //     <button
            //       id="ember5839"
            //       className="tooltip-container ember-view btn btn-primary d-flex align-items-center"
            //       type="button"
            //       onClick={() => setShow(true)}
            //     >
            //       <AddIcon />
            //       New
            //     </button>
            //   </>
            // }
          />
        </div>
      </div>
      <Toaster />
    </>
  );
};

export default TCS;
